import { useState } from 'react'

function NavbarPublico({ onIrALogin, onIrARegistro, onIrAInicio, vistaActiva }) {
  const [menuAbierto, setMenuAbierto] = useState(false)

  function irALogin() { onIrALogin && onIrALogin(); setMenuAbierto(false) }
  function irARegistro() { onIrARegistro && onIrARegistro(); setMenuAbierto(false) }
  function irAInicio() { onIrAInicio ? onIrAInicio() : onIrALogin && onIrALogin(); setMenuAbierto(false) }

  return (
    <nav style={estilos.nav}>
      <div style={estilos.contenido}>
        <div style={estilos.marca}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logo-circulo.png" alt="Etern-me" style={estilos.logoImg} />
          </a>
          <span style={estilos.nombre}>ETERN-ME</span>
        </div>
        <button style={estilos.hamburguesa} onClick={() => setMenuAbierto(!menuAbierto)}>
          {menuAbierto ? '✕' : '☰'}
        </button>
      </div>

      {menuAbierto && (
        <div style={estilos.menuMovil}>
          {vistaActiva === 'inicio' && (
            <>
              <button style={estilos.menuBtn} onClick={irALogin}>Iniciar sesión</button>
              <button style={estilos.menuBtnDestacado} onClick={irARegistro}>Probar 14 días gratis</button>
            </>
          )}
          {vistaActiva === 'login' && (
            <>
              <button style={estilos.menuBtn} onClick={irAInicio}>← Inicio</button>
              <button style={estilos.menuBtnDestacado} onClick={irARegistro}>Probar 14 días gratis</button>
            </>
          )}
          {vistaActiva === 'registro' && (
            <>
              <button style={estilos.menuBtn} onClick={irALogin}>Iniciar sesión</button>
              <button style={estilos.menuBtn} onClick={irAInicio}>← Inicio</button>
            </>
          )}
          {vistaActiva === 'legal' && (
            <>
              <button style={estilos.menuBtn} onClick={irAInicio}>← Inicio</button>
              <button style={estilos.menuBtn} onClick={irALogin}>Iniciar sesión</button>
              <button style={estilos.menuBtnDestacado} onClick={irARegistro}>Probar 14 días gratis</button>
            </>
          )}
        </div>
      )}
    </nav>
  )
}

const estilos = {
  nav: { backgroundColor: '#2C1810', borderBottom: '1px solid #3D2418', position: 'fixed', top: 0, zIndex: 100, width: '100%' },
  contenido: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: '1100px', margin: '0 auto', padding: '0 20px', height: '64px' },
  marca: { display: 'flex', alignItems: 'center', gap: '8px' },
  logoImg: { width: '40px', height: '40px', objectFit: 'contain', borderRadius: '50%' },
  nombre: { color: '#FAF8F5', fontSize: '15px', fontWeight: '700', letterSpacing: '0.5px', whiteSpace: 'nowrap' },
  hamburguesa: { backgroundColor: 'transparent', border: 'none', color: '#FAF8F5', fontSize: '22px', cursor: 'pointer', padding: '4px 8px', lineHeight: 1 },
  menuMovil: { backgroundColor: '#2C1810', borderTop: '1px solid #3D2418', display: 'flex', flexDirection: 'column', padding: '8px 0' },
  menuBtn: { backgroundColor: 'transparent', border: 'none', color: '#E8D5B7', padding: '14px 20px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', textAlign: 'left' },
  menuBtnDestacado: { backgroundColor: 'transparent', border: 'none', color: '#C4A882', padding: '14px 20px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', textAlign: 'left', borderTop: '1px solid #3D2418' },
}

export default NavbarPublico